import { DsFormTemplateTreeInterface } from '../interfaces/foms-models/ds-form-template-tree.interface';

export class DsFormTemplateTree {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public children?: DsFormTemplateTree[];

  /**
   * Creates an instance of DsFormInstanceWithTemplate.
   *
   * @param json the json data
   */
  constructor(json: DsFormTemplateTreeInterface) {
    this.id = json.id;
    this.children = json.children ? json.children.map((child) => new DsFormTemplateTree(child)) : [];
  }
}
